export const buildMonthlyAmtArr = (assetArr, expenseArr, loanArr, jobName) => {
    let amountArr = [];
    let assets = 0;
    let itemDesc = "";
    let monthlyObj = {};
    for (let i=0; i<assetArr.length; i++){
       assets += +assetArr[i].assetAmt;
       monthlyObj = {itemName: assetArr[i].assetItem, itemDesc: assetArr[i].assetDesc,
            itemAmt: assetArr[i].assetAmt, total: false
       }
       amountArr.push(monthlyObj);
    }
    monthlyObj = {itemName: "Total Income", itemDesc: "" , itemAmt: assets, total:true};
    amountArr.push(monthlyObj);
    let expenses = 0;
    for (let i=0; i< expenseArr.length; ++i) 
    {
        expenses -= +expenseArr[i].expAmount;
        monthlyObj = {itemName: expenseArr[i].expItem, itemDesc: expenseArr[i].expDesc,
            itemAmt: -expenseArr[i].expAmount, total: false }
        amountArr.push(monthlyObj);
    }  
    monthlyObj = {itemName: "Total Expenses", itemDesc: "" , itemAmt: expenses, total: true};
    amountArr.push(monthlyObj);
    let loans = 0;
    if (loanArr.length > 0){
         let loanTypes = [];
         for(let i=0; i<loanArr.length; i++){
            loans -= +loanArr[i].loanAmt; 
            loanTypes.push(loanArr[i].loanType);
            monthlyObj = {itemName: loanArr[i].loanType, itemDesc: loanArr[i].loanDesc,
                itemAmt: -loanArr[i].loanAmt, total: false }
            amountArr.push(monthlyObj); 
      }
      monthlyObj = {itemName: "Loan Amounts", itemDesc: "" , itemAmt: loans, total: true};
      amountArr.push(monthlyObj);
    }
    // note expenses and loans are negative amounts
    let totalAmt = (assets + expenses + loans).toFixed(2);
    let monthlyTotalAmt = totalAmt;
    itemDesc = "";
    monthlyObj = {itemName: "Total Monthly Amount", itemDesc: itemDesc , itemAmt: monthlyTotalAmt, total: true};
    amountArr.push(monthlyObj);
    return amountArr;

}
export default buildMonthlyAmtArr;